import { appConstants } from "../_constants";
import { appHelpers } from "../_helpers";

export const externalPaymentService = {
  searchInvoiceDetails,
  getSubInvoiceRRR,
  getRRR,
  handlePaymentPaystack,
  handleRevopsPayment,
  verifyPayment,
};

// issues witht the api using passerrelle on prod, you can use this back if it is stable
function searchInvoiceDetails(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.APP_URL}/api/Open/SearchInvoice?invNum=${payload.invNum}&agencyId=${payload.agencyId}`,
      // `http://bda-new.test.vggdev.com/api/Open/SearchInvoice?invNum=${payload.invNum}&agencyId=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getSubInvoiceRRR(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.APP_URL}/api/Open/GenerateSubInvoice`,
      payload
    )
    .then((res) => {
      const { error } = res.response;
      if (!error) {
        return res;
      } else {
        return appHelpers.formatPromiseResponse(
          error,
          appConstants.ERROR_RESPONSE
        );
      }
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getRRR(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.APP_URL}/api/Open/GenerateRRR?invNum=${payload.invNum}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function handlePaymentPaystack(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.APP_URL}/api/Open/GetAvailableGateways?invoiceNumber=${payload.invNum}&agencyId=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function handleRevopsPayment(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.APP_URL}/api/Open/GetAvailableGateways?invoiceNumber=${payload.invNum}&agencyId=${payload.agencyId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function verifyPayment(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.APP_URL}/api/Open/verifyPayment?inv=${payload.inv}&rrr=${payload.rrr}&gwid=${payload.gwId}`,
      null
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}
